import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// angular
import { Component, OnInit, Inject, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// rxjs
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';

// kendo
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';

// models
import { UniversalCalculationItem, UniBrandSubReport } from 'app/_models';
import { UserProfile, CaseShort, CaseDetailsProperty } from 'app/_models';

// services
import { LossAdjusterService, CaseService, WISEService, SharedService } from 'app/_services';

// 3rd party
import { ToastrService } from 'ngx-toastr';
import { LocalForageService } from 'ngx-localforage';
import * as _lodash from 'lodash';
import * as _underscore from 'underscore';

@Component({
    selector: 'grid-universalcalculation-view',
    templateUrl: './universalcalculation-view.grid.component.html'
})
export class GridUniversalCalculationView implements OnInit, OnDestroy {
    public view: any[] = [];
    public gridState: State = {
        sort: [],
        skip: 0,
        take: 10
    };

    public profile: UserProfile = new UserProfile();

    public caseShort: CaseShort = new CaseShort();

    public editDataItem: UniversalCalculationItem;
    public isNew: boolean;
    public subReportData: any = [];
    public selectedSubReport: any;
    public universalCalculationData: Array<any> = [];
    public reportFormType: string = null;

    constructor(
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private caseService: CaseService,
        private localForage: LocalForageService,
        private lossAdjusterService: LossAdjusterService,
        private wiseService: WISEService,
        private element: ElementRef,
        private sharedService: SharedService,
        private editService: LossAdjusterService
    ) {
        this.route.params.subscribe(params => {
            const caseData: CaseShort = new CaseShort();
            caseData.CaseID = params['caseID'];

            this.caseService.setCase(caseData);

            this.sharedService.emitChange({ action: 'preloader', value: true });
            this.caseShort.CaseID = params['caseID'];

            this.initGrid(params['caseID']);
        });

    }

    private initGrid(caseID: string): void {
        if (caseID) {
            this.sharedService.emitChange({ action: 'preloader', value: true });

            const join = [];

            join.push(this.wiseService.getUniBrandSubReportList(caseID));
            join.push(this.lossAdjusterService.getUniversalCalculationData(caseID));
            join.push(this.wiseService.getUniBrandCalculationModels(caseID));

            forkJoin(join)
                .subscribe((results: any[]) => {
                    const uniBrandDataResult = results[0];
                    let calculationModels = [];
                    let universalCalculations = [];

                    if (uniBrandDataResult) {
                        this.subReportData = results[2];

                        if (this.subReportData) {
                            this.subReportData.forEach(subReport => {
                                const prcID = _lodash.pick(subReport, 'ProductionReportCalculationID');

                                calculationModels.push({
                                    ProductionReportCalculationID: prcID.ProductionReportCalculationID,
                                    LongName: subReport.LongName
                                });
                            });
                        }
                    }

                    this.universalCalculationData = results[1];

                    if (this.universalCalculationData) {
                        this.universalCalculationData.forEach(universalCalculation => {
                            const uc = _lodash.pick(universalCalculation.SubReport, 'ProductionReportCalculationID'); 

                            universalCalculations.push({
                                ProductionReportCalculationID: uc.ProductionReportCalculationID,
                                LongName: universalCalculation.SubReport.LongName
                            });
                        });

                        universalCalculations = _lodash.uniqBy(universalCalculations, 'ProductionReportCalculationID');
                    }

                    // tslint:disable-next-line: max-line-length
                    const universalCalculationDiff =  _lodash.differenceBy(universalCalculations, calculationModels, 'ProductionReportCalculationID');

                    if (universalCalculationDiff.length === 0) {
                        console.log('no diff');
                    } else {
                        this.toastr.warning('Rapportvorm is aangepast in WISE', 'Schadevaststelling');
                    }

                    if (this.universalCalculationData) {
                        if (!this.universalCalculationData) {
                            this.universalCalculationData = [];
                        }

                        this.view = this.universalCalculationData;
                    }

                    this.sharedService.emitChange({ action: 'preloader', value: false });
                });
        }
    }

    public saveUniBrand(): void {
        this.sharedService.emitChange({ action: 'preloader', value: true });
        this.toastr.warning('Opslaan data', 'Schadevaststelling');

        this.lossAdjusterService
            .saveUniBrand(this.caseShort.CaseID, this.universalCalculationData, this.profile.emailAddress)
            .subscribe(data => {
                this.sharedService.emitChange({ action: 'preloader', value: false });
                this.toastr.success('Data opgeslagen', 'Schadevaststelling');
            });
    }

    public syncUniversalCalculationToWISE(): void {
        this.sharedService.emitChange({ action: 'preloader', value: true });

        this.wiseService.getCaseReportType(this.caseShort.CaseID)
            .subscribe(result => {
                if (result) {
                    this.reportFormType = result.ReportForm;

                    if (this.reportFormType === null || this.reportFormType === undefined) {
                        // this.toastr.error('Er is geen rapportvorm gekozen voor dit dossier in WISE', 'Dossier', {
                        //     timeOut: 30 * 1000
                        // });

                        this.sharedService.emitChange({ action: 'preloader', value: false });
                    } else {
                        this.toastr.success('Syncen met WISE', 'Dossier');

                        this.wiseService.syncUniversalCalculationToWISE(this.caseShort.CaseID).subscribe(data => {
                            this.toastr.success('Syncen uitgevoerd', 'Case');
                            this.sharedService.emitChange({ action: 'preloader', value: false });
                        });
                    }
                }
            });
    }

    public selectedCalculationModel(e: any, selectedItem: any): void {
        if (e) {
            this.selectedSubReport = selectedItem;
            this.selectedSubReport.CaseID = this.caseShort.CaseID;

            this.addHandler();
        }
    }

    public addHandler(): void {
        this.editDataItem = new UniversalCalculationItem();
        this.editDataItem.VATType = this.selectedSubReport.VatInclExclNvtTC;
        this.isNew = true;
    }

    public editHandler({ dataItem }): void {
        this.editDataItem = dataItem;
        this.isNew = false;
    }

    public cancelHandler(): void {
        this.editDataItem = undefined;
    }

    public saveHandler(uci: UniversalCalculationItem): void {
        if (uci) {
            if (this.isNew) {
                const measurement = uci;

                measurement.PartID = (this.view.length + 1);

                this.universalCalculationData.push(measurement);
                this.view = this.universalCalculationData;
            } else {
                Object.assign(
                    this.universalCalculationData.find(({ PartID }) => PartID === uci.PartID), uci
                );
                this.view = this.universalCalculationData;
            }
        }

        this.editDataItem = undefined;
    }

    public removeHandler({ dataItem }): void {
        const index = _lodash.findIndex(this.universalCalculationData, dataItem);

        this.universalCalculationData.splice(index, 1);
        this.view = this.universalCalculationData;
    }

    public checkReportFormType(caseID: string) {
        this.wiseService.getCaseReportType(this.caseShort.CaseID)
            .subscribe(result => {
                if (result) {
                    this.reportFormType = result.ReportForm;

                    if (this.reportFormType === null || this.reportFormType === undefined) {
                        // this.toastr.error('Er is geen rapportvorm gekozen voor dit dossier in WISE', 'Dossier', {
                        //     timeOut: 30 * 1000
                        // });
                    }
                }

                this.sharedService.emitChange({ action: 'preloader', value: false });
            });
    }

    public ngOnInit(): void {
        this.sharedService.emitChange({ action: 'preloader', value: true });

        this.checkReportFormType(this.caseShort.CaseID);
    }

    public ngOnDestroy(): void {
        this.saveUniBrand();
    }
}
